/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import NotificationMange from "./_components/NotificationMange";
import TriggerManage from "./_components/TriggerManage";
import HistoryMange from "./_components/HistoryMange";

import { useFetchNotificationsData } from "../../apis/notificationApis";

const Notification: React.FC = () => {
  const [activeRole, setActiveRole] = useState("Notification");
  const [activeItem, setActiveItem] = useState("inhouse");

  const roles = ["Notification", "History"];
  const roles2 = ["inhouse", "Customer"];


  const isCustomerView =
    activeRole === "Notification" && activeItem === "Customer";
  
  return (
    <div className="p-4 space-y-4">
      {/* Header */}
      {/* <div className="flex justify-between items-center">
        <h1 className="text-3xl text-[#212121]">Notification Management</h1> 
        {activeRole === "Notification" && (
          <RoleToggle
            options={roles2}
            active={activeItem}
            onChange={setActiveItem}
          />
        )}
      </div> */}

      {/* {!isCustomerView && (
        <RoleToggle
          options={roles}
          active={activeRole}
          onChange={setActiveRole}
        />
      )} */}

      <NotificationMange />

      {/* {activeRole === "Notification" && (
        <>
          {activeItem === "inhouse" && <NotificationMange />}
          {activeItem === "Customer" && <TriggerManage />}
        </>
      )}

      {activeRole === "History" && <HistoryMange />} */}
    </div>
  );
};

export default Notification;
